import { BaseEntity } from '@starsoft/common/models/base-entity';
import { LanguageDictionary } from '@starsoft/common/models/language-dictionary';
import { TimeFrame } from '../time-frame';
import { TimePeriodId, TimePeriodIdType } from './id';

/**
 * Entity representing a Time Period Definition
 * @class TimePeriod
 * @extends {BaseEntity<TimePeriod>}
 * @description Defines configurable time periods (e.g., daily, weekly, monthly) used for data organization and filtering
 */
class TimePeriod extends BaseEntity {
  /**
   * Name of the time period in multiple languages
   * @type {LanguageDictionary}
   * @description Localized name for this time period
   * @example { "en": "Daily", "es": "Diario" }
   */
  name: LanguageDictionary;

  /**
   * Duration of the period in the specified time frame units
   * @type {number}
   * @example 1 for one day/week/month depending on the frame
   */
  duration: number;

  /**
   * Foreign key reference to the TimeFrame entity
   * @type {bigint}
   */
  frameId: bigint;

  /**
   * Relationship to TimeFrame entity defining the unit of time measurement
   * @type {TimeFrame}
   * @example TimeFrame could be "day", "week", "month"
   */
  frame: TimeFrame;
}

export { TimePeriod, TimePeriodId };
export type { TimePeriodIdType };
